import React, { Component } from 'react';
import { Link } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import FlatButton from "material-ui/FlatButton";
import ContentCreate from "material-ui/svg-icons/content/create";
import { TextInput } from "components/input";
import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';

import * as utils from './utils';
import * as urls from "./urls";
import { saveDataRecordSelected } from "actions/recordSelectedActions";


const NowOchaShopsListFilter = (props) => (
  <FilterForm {...props} initialValues={props.defaultSearchValue}>
    <TextInput source="phone" label="Owner mobile"/>
    <TextInput source="shop_id" label="Ocha shop ID"/>
    <TextInput source="restaurant_id" label="Now restaurant ID"/>
  </FilterForm>
);

class ChangeDeliveryButton extends Component {
  constructor(props) {
    super(props);
    this.saveCurrentShopData = this.saveCurrentShopData.bind(this);
  }

  saveCurrentShopData() {
    this.props.dispatch(saveDataRecordSelected(utils.NowOchaShopResourceName, this.props.record));
  }

  render() {
    const {record} = this.props;
    if ([
      utils.MAPPING_REQUEST_STATUS_APPROVED,
      utils.MAPPING_REQUEST_STATUS_UNLINKED_FOODY,

    ].includes(record.status)) {
      return (
        <div onClick={this.saveCurrentShopData}>
          <FlatButton
            primary
            label='Change Status'
            icon={<ContentCreate/>}
            containerElement={(<Link to={urls.nowOchaShopsChangeDeliveryFrontendPath}/>)}
            style={{ overflow: 'inherit', whiteSpace: 'nowrap' }}
          />
        </div>
      )
    }
    return null;
  }
}
const ChangeDeliveryButtonConnected = connect()(ChangeDeliveryButton);

class RequestStatusTextField extends Component {
  render() {
    const {record} = this.props;
    const statusName = utils.MAPPING_REQUEST_STATUS_CODE_NAME[record.status];
    return (
      <span>{statusName}</span>
    );
  }
}

class DeliveryStatusTextField extends Component {
  render() {
    const { record } = this.props;
    return (
      <span>
        {utils.DELIVERY_STATUS_NAME[!!record.has_now_delivery]}
      </span>
    );
  }
}

class NowOchaShopsList extends Component {

  render() {
    const {filterValues} = this.props;
    let autoLoadData = false;
    if (filterValues && Object.keys(filterValues).length > 0) {
      autoLoadData = true;
    }

    return (
      <List
        {...this.props}
        filters={<NowOchaShopsListFilter defaultSearchValue={filterValues}/>}
        autoLoadData={autoLoadData}
      >
        <Datagrid bodyOptions={{stripedRows: true, showRowHover: true}}>
          <TextField source="shop_id" label="Ocha shop ID" />
          <TextField source="restaurant_id" label="Now Rest. ID" />
          <TextField source="phone" label="Owner mobile" />
          <TextField source="name" label="Ocha shop name" />
          <TextField source="restaurant_name" label="Now restaurant name" />
          <RequestStatusTextField label="Request Status" />
          <DeliveryStatusTextField label="Delivery Status" />
          <ChangeDeliveryButtonConnected />
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    filterValues: state.admin.filter[utils.NowOchaShopResourceName],
  })
)(NowOchaShopsList);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/NowOchaShopsList.js